import { useCallback, useEffect } from 'react'

import { useAbortController } from 'core/ui/hooks/useAbortController'
import { useAsync } from 'core/ui/hooks/useAsync'

import { getOpenDockWarehouseDetails } from '../../use-cases/getOpenDockWarehouseDetails'

export function useGetOpenDockWarehouseDetails(
  shipmentUUID: string,
  stopIndex: number,
  enabled: boolean
) {
  const { call, result, status, error } = useAsync(getOpenDockWarehouseDetails)
  const abortController = useAbortController()

  const fetchOpenDockWarehouseDetails = useCallback(
    () =>
      call({
        shipmentUUID,
        stopIndex,
        config: abortController,
      }),
    [abortController, call, shipmentUUID, stopIndex]
  )

  useEffect(() => {
    if (enabled) {
      fetchOpenDockWarehouseDetails()
    }
  }, [enabled, fetchOpenDockWarehouseDetails])

  return {
    warehouseDetails: result,
    status,
    error,
    fetchOpenDockWarehouseDetails,
  }
}
